/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IdentityProviderTokenValidationRequestDto } from '../models/IdentityProviderTokenValidationRequestDto';
import type { IdentityProviderTokenValidationResultDto } from '../models/IdentityProviderTokenValidationResultDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class IdentityProviderInternalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param body
     * @returns IdentityProviderTokenValidationResultDto OK
     * @throws ApiError
     */
    public postInternalV1IdentityProvidersUserInfo(
        body?: IdentityProviderTokenValidationRequestDto,
    ): CancelablePromise<IdentityProviderTokenValidationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/v1/identity-providers/user-info',
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
